export const ADD_PRODUCT = 'ADD_PRODUCT';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const FILTER_SIZE = 'FILTER_SIZE';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const FETCH_PRODUCTS_FAILD = 'FETCH_PRODUCTS_FAILD';

export const PURCHASE_PRODUCTS_START = 'PURCHASE_PRODUCTS_START';
export const PURCHASE_PRODUCTS_SUCCESS = 'PURCHASE_PRODUCTS_SUCCESS';
export const PURCHASE_PRODUCTS_FAIL = 'PURCHASE_PRODUCTS_FAIL';
export const PURCHASE_PRODUCTS = 'PURCHASE_PRODUCTS';
export const INIT_PURCHASE = 'INIT_PURCHASE';

export const FETCH_ORDERS_START = 'FETCH_ORDERS_START';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAIL= 'FETCH_ORDERS_FAIL';
export const FETCH_ORDERS = 'FETCH_ORDERS';

export const DELETE_ORDER = 'DELETE_ORDER';
export const DELETE_ORDER_SUCCESS= 'DELETE_ORDER_SUCCESS';
export const DELETE_ORDER_ERROR= 'DELETE_ORDER_ERROR';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS= 'AUTH_SUCCESS';
export const AUTH_FAIL= 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT = 'SET_AUTH_REDIRECT';

export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
